export enum Timing {
    FUTURE = 'Future',
    IMMINENT = 'Imminent',
    IMMEDIATE = 'Immediate',
}
